import React, { useMemo, useState, useEffect, useRef } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateRaindropFormContext,
  CreateRaindropFormState,
  buildCreateRaindropFormStateDefault,
  createRaindropSchemaDefault,
} from '@Forms/raindrop/CreateRaindropFormContext';

export const CreateRaindropFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateRaindropFormState>>>(
    createRaindropSchemaDefault
  );
  const schemaRef = useRef(schema);

  useEffect(() => {
    schemaRef.current = schema;
  }, [schema]);

  const resolver = useMemo(() => {
    return async (values: CreateRaindropFormState, context: unknown, options: unknown) => {
      const currentResolver = yupResolver(schemaRef.current);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (currentResolver as any)(values, context, options);
    };
  }, []);

  const methods = useForm({
    defaultValues: buildCreateRaindropFormStateDefault(),
    resolver,
    mode: 'onChange',
  });

  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateRaindropFormContext.Provider value={value}>
      {children}
    </CreateRaindropFormContext.Provider>
  );
};
